<template>
  <div class="portfolio-modular">
    <MyHeader></MyHeader>
    <HeaderMenu></HeaderMenu>
    <ShareRight></ShareRight>
    <div class="header-modular">
      <!-- <img class="banner-bg-img" src="../assets/commodity-portfolio/portfolio-banner-img.png" alt=""> -->
      <img class="banner-bg-img" :src="bannerImg" alt="" @click="toUrl" />
      <!-- <div class="header-banner-portfolio-title-modular">
        <span class="portfolio-title">{{ $t("translateText.commoditydiscountitemText1") }}
          &nbsp;{{ $t("translateText.commoditydiscountitemText2") }}</span>
      </div> -->
    </div>
    <div class="body-modular">
      <div class="header-menu-bar-modular">
        <div class="menu-bar">
          <div class="menu-bar-item">
            <span class="top-bar-title" @click="toPersonCenter()">{{
              currLanguage == 3 ? "Home" : pageTextArr[5]
            }}</span>
            <img
              class="top-bar-icon"
              src="../assets/productDetail/top-bar-icon.png"
              alt=""
            />
          </div>
          <div class="menu-bar-item">
            <span class="top-bar-title">{{ pageTextArr[6] }}</span>
          </div>
        </div>
      </div>
      <!-- <div style="margin-top:20px;">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          {{currLanguage==3?"Home":pageTextArr[5]}}
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ pageTextArr[6] }}
        </el-breadcrumb-item>
      </el-breadcrumb>
      </div> -->
      <div
        class="commodity-portfolio-show-modular"
        v-loading="portfolioListloading"
      >
        <div
          v-if="portfolioList.length == 0"
          class="my-evaluate-bodu-none"
          style="padding-bottom: 80px"
        >
          <img class="none-icon" src="../assets/public/none-icon.png" alt="" />
          <p class="none-title">{{ pageTextArr[0] }}~</p>
        </div>
        <div
          v-else
          class="commodity-portfolio-show-item"
          v-for="(item, index) in portfolioList"
          :key="index"
        >
          <el-row :gutter="10">
            <el-col :xs="24" :span="15">
              <el-row :gutter="10" style="display: flex; flex-wrap: wrap">
                <el-col
                  :xs="12"
                  :span="12"
                  v-for="(item2, index2) in item.product"
                  :key="index2"
                >
                  <div class="show-item-produce">
                    <div class="show-item-produce-1">
                      <img class="produce-img" :src="item2.cover" alt="" />
                      <div class="produce-info">
                        {{ currLanguage == 3 ? item2.eng_title : item2.title }}
                      </div>
                      <div class="produce-price">
                        {{ currencySymbol + item2.price }}
                      </div>
                    </div>
                    <div
                      class="show-item-produce-add"
                      v-if="isShowAddIcon(index2, item.product.length)"
                    >
                      <img
                        class="portfolio-add-icon"
                        src="../assets/commodity-portfolio/portfolio-icon-1.png"
                        alt=""
                      />
                    </div>
                    <div v-else style="width: 40px"></div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :span="9">
              <div class="portfolio-price-modualr">
                <div class="commodity-portfolio-show-item-center">
                  <img
                    class="portfolio-center-icon"
                    src="../assets/commodity-portfolio/portfolio-icon-2.png"
                    alt=""
                  />
                </div>
                <div class="show-price-modular">
                  <div class="portfolio-price">
                    <span class="portfolio-pric-title">
                      <!-- {{  $t("translateText.combinedpriceText") }} -->
                      {{ pageTextArr[1] }}
                      ：</span
                    >
                    <span class="portfolio-pric-num">{{
                      currencySymbol + item.total_discount_price
                    }}</span>
                  </div>
                  <div class="savings-price">
                    <span class="savings-pric-title">
                      {{ pageTextArr[2] }}
                      ：</span
                    >
                    <span class="savings-pric-num">{{
                      currencySymbol + item.discount_price
                    }}</span>
                  </div>
                  <div class="btn-modualr">
                    <el-button
                      class="buy-btn"
                      @click="settlement(item, item.total_discount_price)"
                    >
                      <!-- {{ $t("translateText.buynowText") }} -->
                      {{ pageTextArr[3] }}
                    </el-button>
                    <el-button
                      class="add-btn"
                      @click="productAddCart('', '', 2, item.id, 1)"
                    >
                      <!-- {{  $t("translateText.addCartText") }} -->
                      {{ pageTextArr[4] }}
                    </el-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="pagination-footer-modualr" v-if="portfolioList.length != 0">
        <el-pagination
          :pager-count="11"
          background
          layout="prev, pager, next"
          :total="pageCount"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currencySymbol:
        localStorage.getItem("currencySymbol") == null
          ? "$"
          : localStorage.getItem("currencySymbol"),
      page: 1,
      pagesize: 10,
      pageCount: 0, //总数
      portfolioList: [], //组合商品数据
      portfolioListloading: false, //loading
      currLanguage: localStorage.getItem("curLanguageType"),
      pageText: {
        discountitemText1: "组合购买",
        discountitemText2: "优惠多多",
        NoDataText: "暂无数据",
        combinedpriceText: "组合价",
        economizeText: "节省",
        appraiseText: "评价",
        certificate: "券",
        collectText: "收藏",
        buynowText: "立即购买",
        addCartText: "加入购物车",
      },
      pageTextArr: [
        "暂无数据",
        "组合价",
        "节省",
        "立即购买",
        "加入购物车",
        "首页",
        "组合商品",
      ],
      bannerImg: "",
      url: "",
      is_jump: null,
      itemName: "",
    };
  },
  methods: {
    /**
     * 判断是否显示+
     * @param {*} index
     * @param {*} length
     */
    isShowAddIcon(index, length) {
      let that = this;
      let isShowFlag = false;
      if ((index + 1) % 2 == 1) {
        if (length - 1 == index) {
          isShowFlag = false;
        } else {
          isShowFlag = true;
        }
      }
      return isShowFlag;
    },

    /**
     * 跳转优惠劵
     */
    toCoupon() {
      this.$router.push({
        path: "/commodityCoupon",
        query: { name: "", age: "" },
      });
    },

    /**
     * 分页-page发送变化
     */
    handleCurrentChange(val) {
      this.page = val;
      this.getAllListBycombination();
    },

    /**
     * 组合活动下的商品
     */
    getAllListBycombination() {
      let that = this;
      that.portfolioListloading = false;
      let data = {
        page: that.page,
        pagesize: that.pagesize,
        exchange_rate: localStorage.getItem("currencyRate"),
        exchange_rate_symbol: localStorage.getItem("currencySymbol"),
      };
      this.$http.getAllListBycombination(
        data,
        (res) => {
          if (res.ret == 1) {
            // 组合商品-数据
            that.portfolioList = res.data;
            that.portfolioListloading = false;
            if (
              this.currLanguage != 1 &&
              this.currLanguage != 3 &&
              res.data.length > 0
            ) {
              that.languageTranslateByArrs(res.data, 2);
            }
            that.pageCount = parseInt(res.total);
            // console.log('portfolioList--', that.portfolioList);
          } else {
            this.$message.error(res.msg);
            that.portfolioListloading = false;
          }
        },
        (res) => {
          // this.$message.error(res.msg);
          that.portfolioListloading = false;
        }
      );
    },

    /**
     * 商品加入购物车
     * @param {*} product_id
     * @param {*} sku_number
     * @param {*} type
     * @param {*} portfolio_sales_middle_id
     * @param {*} cartNum
     */
    productAddCart(
      product_id,
      sku_number,
      type,
      portfolio_sales_middle_id,
      cartNum
    ) {
      let that = this;
      // if (this.$parent.tipsLogin()) return;
      that.$parent.addCart(
        product_id,
        sku_number,
        type,
        portfolio_sales_middle_id,
        cartNum
      );
      //
      that.$parent.cartNum++;
    },

    /**
     * 立即购买
     * @param {*} item
     * @param {*} productPrice
     */
    settlement(item, productPrice) {
      let that = this;
      if (this.$parent.tipsLogin()) return;
      let productData = [];
      productData.push({
        product_id: item.product[0].id,
        sku_number: item.product[0].number,
        type: 2,
        num: 1,
        typeid: item.product[0].typeid,
        has_discount: "",
        has_wholesale_price: "",
        wholesale_price_id: "",
        cart_id: "",
        portfolio_sales_middle_id: item.product[0].middle_id,
      });
      // return
      let localStorageProductData = {
        productData: productData,
        productPrice: productPrice,
      };
      localStorage.setItem(
        "localStorageProductData",
        JSON.stringify(localStorageProductData)
      );

      this.$router.push({
        path: "/confirmOrder",
        // query: {
        //   data: productData,
        //   productPrice: productPrice,
        // }
      });
    },

    /**
     * 翻译
     */
    pageTranslate() {
      let that = this;
      let transformText = "";
      for (const key in that.pageText) {
        transformText += key + "=" + that.pageText[key] + "&";
      }
      // that.languageTranslate(transformText);
    },

    /**
     * 语言翻译 - 单个词语
     * @param {*} text
     */
    languageTranslate(text) {
      let that = this;
      this.$parent.translate(
        text,
        (res) => {
          // 处理页面死数据
          that.processingResults(res.data);
        },
        (res) => {}
      );
    },
    /**
     * 处理返回的结果
     */
    processingResults(data) {
      let that = this;
      let textArr = data.split("&amp;");

      textArr.forEach((v, i) => {
        if (v != "") {
          // console.log('v-v',v.split('=')[0],v.split('=')[1]);
          for (const key in that.pageText) {
            if (v.split("=")[0] == key) {
              that.pageText[key] = v.split("=")[1];
              // console.log(' that.pageText[key]', that.pageText[key]);
            }
          }
        }
      });
      // console.log('pageText.magnanimityDrawTex',that.pageText.magnanimityDrawTex);
    },
    /**
     * 获取banner列表
     */
    getBannerList(type) {
      let that = this;
      let data = {
        page: 1,
        pagesize: 3,
        type_id: type,
      };
      this.$http.getBannerList(data, (res) => {
        // console.log(res);
        if (res.ret == 1) {
          that.bannerImg = res.data[0].url;
          that.is_jump = res.data[0].is_jump;
          if (res.data[0].is_jump == 2) {
            that.url = res.data[0].jump_url;
          }
        }
      });
    },
    /**
     * banner 跳转
     */
    toUrl() {
      if (this.is_jump == 2) {
        window.open(this.url);
      } else {
        return;
      }
    },

    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr, type) {
      let that = this;
      let newpagetextArr = [];
      if (type == 1) {
        that.translateByArr(arr, (res) => {
          console.log("res", res);
          res.data.forEach((item, index) => {
            newpagetextArr.push(item.translation);
          });
          that.pageTextArr = newpagetextArr;
        });
      } else {
        arr.forEach((item, index) => {
          arr[index].product.forEach((item2, index2) => {
            newpagetextArr.push(index + "@" + index2 + "@" + item2.title);
          });
        });

        if (newpagetextArr.length > 0) {
          that.translateByArr(newpagetextArr, (res) => {
            res.data.forEach((v, i) => {
              let index = v.query.split("@")[0];
              let childIndex = v.query.split("@")[1];
              that.portfolioList[index].product[childIndex].title =
                v.translation.split("@")[2];
            });
          });
        }
      }
    },
    /**
     * 跳转首页
     */
    toPersonCenter() {
      this.$router.push({
        path: "/",
      });
    },
  },
  mounted() {
    let that = this;
    let url = window.location.href;
    console.log("url", url);
    localStorage.setItem("url", url);
    that.itemName = this.$route.query.name;
    // 组合活动下的商品
    that.getAllListBycombination();
    // 翻译
    that.pageTranslate();
    this.getBannerList(7);
    that.languageTranslateByArrs(that.pageTextArr, 1);
  },
};
</script>


// WEBPACK FOOTER //
// src/view/commodityPortfolio.vue